import { Component, Input, OnInit } from '@angular/core';
import { Producto } from '../../../_models/producto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { PerfilRiesgo } from '../../../_models/perfil-riesgo';
import { Nivel } from '../../../_models/nivel';
import { NavService } from '../../../_services/_nav.service';
import { Location } from '@angular/common';
import { PerfilRiesgoService } from '../../../_services/perfil-riesgo.service';
import { NivelesService } from '../../../_services/niveles.service';
import { forkJoin } from 'rxjs';
import { ProductoGarantia } from '../../../_models/producto-garantia';
import { ProductoGarantiaService } from '../../../_services/producto-garantia.service';
import {ProductosRespaldos} from '../../../_models/productos-respaldos';
import {ProductosRespaldosService} from '../../../_services/productos-respaldos.service';
import {ListaService} from '../../../_services/lista.service';
import {ListaItem} from '../../../_models/lista-item';
import {SegmentoIngreso} from '../../../_models/segmento-ingreso';

@Component( {
  selector: 'app-producto-respaldos',
  templateUrl: 'producto-respaldos.component.html'
} )

export class ProductoRespaldosComponent implements OnInit {
  @Input() producto: Producto;
  carInformacionInicial = true;
  lisProductosRespaldos: ProductosRespaldos[] = [];
  lisRespaldos: ListaItem[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  ranIncorrecto = false;
  listaRespaldos: SelectItem[] = [];
  rangoDesdeValido = true;
  edit = false;

  constructor( private proRespaldoServicio: ProductosRespaldosService,
               private listaService: ListaService,
               private navServicio: NavService,
               private location: Location,
               private fb: FormBuilder ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'nombreRespaldo', header: this.navServicio.buscarMensaje( 'PRODUCTORESPALDO.LBL_RESPALDOS' ), sort: false },
      { field: 'rangoSMLV', header: this.navServicio.buscarMensaje( 'PRODUCTORESPALDO.LBL_RANGOSMLV' ), sort: false },
      { field: 'indicadorObligatorio', header: this.navServicio.buscarMensaje( 'PRODUCTORESPALDO.LBL_OBLIGATORIO' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    forkJoin( this.proRespaldoServicio.listadoPorProducto( this.producto.idProducto ),
      this.listaService.getMasterDetails( 'ListasRespaldos' ),
      ).subscribe( ( [ lisProductos, listasRespaldos] ) => {
      this.lisRespaldos = listasRespaldos;
      this.lisProductosRespaldos = lisProductos;

      this.listaRespaldos = [];
      listasRespaldos.map( ( s: ListaItem ) => {
        this.listaRespaldos.push( { label: s.nombre, value: s.idLista } );
      } );

      this.cargarFormulario();
      this.carInformacionInicial = false;
    } );

  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idProductoRespaldo: [ null ],
      idProducto: [ this.producto.idProducto, [ Validators.required ] ],
      idRespaldo: [ null, [ Validators.required ] ],
      rangoInferior: [ null, [ Validators.required, Validators.maxLength( 9 ) ] ],
      rangoSuperior: [ null, [ Validators.required, Validators.maxLength( 9 ) ] ],
      indicadorObligatorio: [ false ],
      indicadorHabilitado: [ true ],
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  regresar() {
    this.location.back();
  }

  get segProductosRespaldos() {

    const lista = Object.assign( [], this.lisProductosRespaldos );
    this.lisProductosRespaldos = [];

    lista.map( ( s: ProductosRespaldos ) => {
      s.rangoMonto = s.rangoInferior + ' - ' + s.rangoSuperior;
      this.lisProductosRespaldos.push( s );
    } );

    return this.lisProductosRespaldos;
  }

  onSubmit() {
    console.log('hola');
    this.submitted = true;
    if ( this.formulario.valid && this.rangoDesdeValido ) {
      this.guardando = true;
      const temp: ProductosRespaldos = this.formulario.value;
      const a = this.lisProductosRespaldos.find( sp => sp.idProductoRespaldo === temp.idProductoRespaldo );
      if ( a ) {
        temp.idProductoRespaldo = a.idProductoRespaldo;
      }
      temp.idProducto = this.producto.idProducto;
      temp.indicadorHabilitado = temp.indicadorHabilitado;
      temp.nombreRespaldo = this.lisRespaldos.find( s => s.idLista === temp.idRespaldo).nombre;

      if ( temp.idProductoRespaldo ) {

        this.proRespaldoServicio.actualizar( temp ).subscribe( res => {
          const lista = Object.assign( [], this.lisProductosRespaldos );
          this.lisProductosRespaldos = [];
          lista.map( x => {
            if ( x.idProductoRespaldo === temp.idProductoRespaldo ) {
              x = temp;
            }
            this.lisProductosRespaldos.push( x );
          } );
          this.formulario.reset();
          this.formulario.controls.idProducto.setValue(this.producto.idProducto);
          this.submitted = false;
          this.carInformacionInicial = false;
          this.guardando = false;
          this.edit = false;
          this.navServicio.setMesage( 2 );
        }, error1 => {
          this.navServicio.setMesage( 3 );
          this.carInformacionInicial = false;
          this.guardando = false;
          this.edit = false;
        } );

      } else {
        this.proRespaldoServicio.crear( temp ).subscribe( res => {
          temp.idProductoRespaldo = res.idProductoRespaldo;
          temp.nombreRespaldo = this.lisRespaldos.find( s => s.idLista === temp.idRespaldo).nombre;
          this.lisProductosRespaldos.push( temp );
          this.formulario.reset();
          this.formulario.controls.idProducto.setValue(this.producto.idProducto);
          this.submitted = false;
          this.carInformacionInicial = false;
          this.guardando = false;
          this.navServicio.setMesage( 1 );
        }, error1 => {
          this.navServicio.setMesage( 3 );
          this.carInformacionInicial = false;
          this.guardando = false;
        } );
      }
    }
  }


  validarValor( event: any, desde: boolean ) {
    const rangoDesde = this.formulario.controls.rangoInferior.value;
    const rangoHasta = this.formulario.controls.rangoSuperior.value;
    if ( desde && rangoHasta ) {
      if ( Number( rangoDesde ) >= Number( rangoHasta ) ) {
        this.rangoDesdeValido = false;
      } else {
        this.rangoDesdeValido = true;
      }
    } else if ( !desde && rangoDesde ) {
      if ( Number( rangoDesde ) >= Number( rangoHasta ) ) {
        this.rangoDesdeValido = false;
      } else {
        this.rangoDesdeValido = true;
      }
    }
  }

  editar( row: ProductosRespaldos ): void {
    this.edit = true;
    this.submitted = false;

    this.formulario = this.fb.group( {
      idProductoRespaldo: [ row.idProductoRespaldo ? row.idProductoRespaldo : null ],
      idProducto: [ this.producto.idProducto, [ Validators.required ] ],
      idRespaldo: [ row.idRespaldo ? row.idRespaldo : null , [ Validators.required ] ],
      rangoInferior: [ row.rangoInferior ? row.rangoInferior : null , [ Validators.required, Validators.maxLength( 9 ) ] ],
      rangoSuperior: [ row.rangoSuperior ? row.rangoSuperior : null , [ Validators.required, Validators.maxLength( 9 ) ] ],
      indicadorObligatorio: [ row.indicadorObligatorio ? row.indicadorObligatorio : false ],
      indicadorHabilitado: [ row.indicadorHabilitado ? row.indicadorHabilitado : false ]
    } );
  }

}
